import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';


import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooldalModule } from './fooldal/fooldal.module';
import { HtmlconvertService } from './services/htmlconvert.service';

import { AngularFireModule } from '@angular/fire/compat';
import { SharedModule } from './shared/shared.module';

import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AdminInterceptorService } from './admin-interceptor';
import { AdatkezelesComponent } from './components/adatkezeles/adatkezeles.component';
import { AszfComponent } from './components/aszf/aszf.component';
import { FooterComponent } from './components/footer/footer.component';
import { GyikComponent } from './components/gyik/gyik.component';
import { HeaderComponent } from './components/header/header.component';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { LostPasswordComponent } from './components/lost-password/lost-password.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { RefreshComponent } from './components/refresh/refresh.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SigninComponent } from './components/signin/signin.component';
import { SignupComponent } from './components/signup/signup.component';
import { SuccessComponent } from './components/success/success.component';
import { UpdateProfileComponent } from './components/update-profile/update-profile.component';
import { CsrfInterceptorService } from './csrf-interceptor';
import { SpecialCharacterDirective } from './directives/special-character.directive';
import { ElofizetesModule } from './elofizetes/elofizetes.module';
import { SharedService } from './services/shared.service';
import { VideoStatusService } from './services/video-status.service';



const firebaseConfig = {
  apiKey: "AIzaSyBSwXraHIkw4DG5uRRsfD_FFqAhMWG5X_w",
  authDomain: "babafeszkelo-51994.firebaseapp.com",
  projectId: "babafeszkelo-51994",
  storageBucket: "babafeszkelo-51994.appspot.com",
  messagingSenderId: "850014304360",
  appId: "1:850014304360:web:4a2ce8a76afee5df2d63dd"
};

@NgModule({
  declarations: [
    AppComponent,
    LoadingSpinnerComponent,
    NotFoundComponent,
    HeaderComponent,
    FooterComponent,
    SigninComponent,
    SignupComponent,
    ResetPasswordComponent,
    AdatkezelesComponent,
    AszfComponent,
    RefreshComponent,
    SpecialCharacterDirective,
    GyikComponent,
    LostPasswordComponent,
    UpdateProfileComponent,
    SuccessComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FooldalModule,
    HttpClientModule,
    RouterModule,
    FontAwesomeModule,
    SharedModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ElofizetesModule,
    AngularFireModule.initializeApp(firebaseConfig)
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CsrfInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AdminInterceptorService,
      multi: true,
    },
    HtmlconvertService, SharedService, VideoStatusService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

